<script>
import { CdrModal, CdrText } from '@rei/cedar';

export default {
  name: 'YoutubeModal',
  components: {
    CdrModal,
    CdrText,
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
      required: true,
    },
    modalDescription: {
      type: String,
      default: '',
      required: true,
    },
    modalTitle: {
      type: String,
      default: '',
    },
    videoId: {
      type: String,
      default: '',
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    youTubeUrl() {
      return (this.opened && `https://www.youtube-nocookie.com/embed/${this.videoId}?autoplay=1`) || null;
    },
    ratioCssVariable() {
      const aspectRatio = 9 / 16;
      return `--ambient-video-ratio: ${aspectRatio};`;
    },
  },
  methods: {
    onModalClose() {
      this.$emit('onModalClose', false);
    },
  },
};
</script>
<template>
  <div class="youtube-modal">
    <cdr-modal
      :opened="opened"
      :show-title="showTitle"
      wrapper-class="youtube-modal__modal"
      overlay-class="youtube-modal__overlay"
      label="Play Youtube video"
      aria-describedby="description"
      @closed="onModalClose"
    >
      <template #title>
        <cdr-text
          tag="h3"
          class="youtube-modal__title"
        >
          {{ modalTitle }}
        </cdr-text>
      </template>

      <cdr-text
        id="description"
        tag="p"
        class="sr-only"
      >
        {{ modalDescription }}
      </cdr-text>
      <div
        :style="ratioCssVariable"
        class="youtube-modal__player-wrapper"
      >
        <iframe
          ref="youtubeFrame"
          :src="youTubeUrl"
          aria-label="YouTube Video Player"
          class="youtube-modal__player-iframe"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </cdr-modal>
  </div>
</template>
<style lang="scss">
@import "@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss";
.youtube-modal {
  &__modal div[role="dialog"] {
    max-width: 95%;
    position: relative;
    background: transparent;
    box-shadow: none;

    @include cdr-sm-mq-up {
      max-width: 80%;
      position: inherit;
    }
  }

  &__overlay {
    background-color: rgba(28,28,26, 0.85); // #1C1C1A in rgba
  }

  &__player-iframe {
    height: 100%;
    width: 100%;
    position: absolute;
    inset: 0;
  }

  &__title {
    @include cdr-text-heading-serif-600;
    color: $cdr-color-text-inverse;
  }

  &__player-wrapper {
    position: relative;
    overflow: hidden;
    border-radius: 8px;

    &::before {
      content: '';
      display: block;
      padding-bottom: calc(100% * var(--ambient-video-ratio));
    }
  }
}
</style>
